import classnames from 'classnames';
import styles from './TwoColumnScaffold.scss';


export const TwoColumnScaffold = (props) =>
    <div className={classnames(styles.twoColumnScaffold, props.className)} data-cy="SideNav-children">{props.children}</div>;

export const LeftColumn = (props) =>
    <div className={classnames(styles.leftColumn, props.className)} data-cy="SideNav-childrens">{props.children}</div>;

export const RightColumn = (props) =>
    <div className={classnames(props.explicitRightColumnStyles ? props.className : styles.rightColumn, props.className)} data-cy="SideNavs-children">{props.children}</div>;

export const FooterRow = (props) =>
    <div className={classnames(props.className)} style={{ ...props.styles }} data-cy="SideNavs-children" > {props.children}</div >;
